import { FC } from "react";

const Menus: FC = () => {
  return <div>Menus</div>;
};

export default Menus;
